/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Badge_OcimfInputs */



/**
* | output |
* | --- |
* | "OCIMF accredited inspectors" |
*
* @param {Home_Badge_OcimfInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const home_badge_ocimf = /** @type {((inputs?: Home_Badge_OcimfInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Badge_OcimfInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("OCIMF 认证检查员")
	return /** @type {LocalizedString} */ ("OCIMF accredited inspectors")
});